// Public modules meant to be consumed by other React components. Any additional generic carousels like these should be
// added in this directory and exported here. The "base" components are not meant to consumed directly.

'use strict';

module.exports = {
    ArrowCarousel: require('./views/ArrowCarousel'),
    SwipeCarousel: require('./views/SwipeCarousel'),
    ScrollCarousel: require('./views/ScrollCarousel')
};



// WEBPACK FOOTER //
// ./assets/js/global/components/carousel/index.es.js